import { NgModule } from '@angular/core';
import { RouterModule, Routes, CanActivate } from '@angular/router';

import { PageMasterComponent } from './pagemaster.component';
import { UserService } from '../services/user.service';

const routes: Routes = [
    {
        path: '', component: PageMasterComponent,
        children: [
            { path: '', loadChildren: 'app/dashboard/dashboard.module#DashboardModule', canActivate: [UserService] }
            , { path: 'elenco-dirette', loadChildren: 'app/elenco-dirette/elenco-dirette.module#ElencoDiretteModule', canLoad: [UserService] }
            , { path: 'visite-dirette', loadChildren: 'app/visite-dirette/visite-dirette.module#VIsiteDiretteModule', canLoad: [UserService] }
            , { path: 'diretta', loadChildren: 'app/match/match.module#MatchModule', canLoad: [UserService] }
        ]
    }
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PageMasterRouting { }


// WEBPACK FOOTER //
// ./src/app/core/masterComponent/pagemaster.routing.ts